import { render, staticRenderFns } from "./customTarget.vue?vue&type=template&id=050ea38e&"
import script from "./customTarget.vue?vue&type=script&lang=js&"
export * from "./customTarget.vue?vue&type=script&lang=js&"
import style0 from "./customTarget.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports